import { execAsync } from "../../../../utils";
import { OffsetPoint } from "../../math/OffsetPoint";
import { PixelPoint } from "../../math/PixelPoint";
import { Shape } from "../../math/Shape";
const getXYFromIdx = (topLeft, width, idx) => OffsetPoint.create(Math.floor(idx / width) + topLeft.x, Math.floor(idx % width) + topLeft.y);
function* yieldAllCoordsWithinRect(topLeft, bottomRight, batchSize = 1) {
    const width = (bottomRight.x - topLeft.x);
    const count = (bottomRight.x - topLeft.x) * (bottomRight.y - topLeft.y);
    let next = [];
    for (let idx = 0; idx < count; idx++) {
        if (next.length === batchSize) {
            yield next;
            next = [];
        }
        next.push(getXYFromIdx(topLeft, width, idx));
    }
    return;
}
export const precacheContours = (topLeftPx, bottomRightPx, zoom) => {
    const topLeft = PixelPoint.toRoundedOffsetPoint(topLeftPx);
    const bottomRight = PixelPoint.toRoundedOffsetPoint(bottomRightPx);
    const count = (bottomRight.x - topLeft.x) * (bottomRight.y - topLeft.y);
    const batchSize = Math.ceil(count / 50);
    // console.log('In precacheContours', {topLeftPx, bottomRightPx, topLeft, bottomRight, count, batchSize, zoom});
    return execAsync({
        name: 'precacheContoursAsync',
        gen: yieldAllCoordsWithinRect(topLeft, bottomRight, batchSize),
        action: (batch) => batch.map(Shape.getHexContour),
        log: false,
    });
};
//# sourceMappingURL=precacheContours.js.map